import React from 'react';

export class Modal extends React.Component {
    handleCloseClick() {
        this.props.set_showModal(false);
    }

    render() {
        if (!this.props.showModal) {
            return null;
        }
        return (
            <div className="modalWrapper" style={{height: this.props.screenHeight.toString() + '%'}}>
                <div className="modal rounded border" style={{maxHeight: (this.props.screenHeight - 140).toString() + 'px'}}>
                    <div onClick={this.handleCloseClick.bind(this)} className="popupClose mouse-pointer" style={{marginTop: "5px"}}>
                        <b>×</b>
                    </div>
                    <p>Die Karte basiert auf <a href="https://experience.arcgis.com/experience/478220a4c454480e823b17327b2bf1d4" target="_blank">Daten</a>, die das Robert-Koch-Institut (RKI) seit Beginn der Corona-Pandemie von den Gesundheitsämtern der Städte und Kreise erfasst. </p>
                    <p>Die aktuellen Werte decken sich dabei nicht überall mit den aktuellen Angaben der Städte und Kreise, da es zu Verzögerungen in der Meldekette kommen kann und die Kommunen ihre Melden stets vor dem RKI veröffentlichen.</p>
                    <p>Der Wert "Neuinfektionen der letzten 7 Tage je 100.000 Einwohner" dient als Kennziffer, um das regionale, aktuelle Infektionsgeschehen zu vergleichen.</p>
                    <p>Um das Infektionsgeschehen vollumfänglich beurteilen zu können, reicht die Zahl der "Neuinfektionen der letzten 7 Tage je 100.000 Einwohner" nicht aus. Für Nordrhein-Westfalen haben wir <a href="https://rp-online.de/49470887" target="_blank">hier</a> alle verfügbaren Daten aufbereitet und zusammenfasst, selbiges haben wir mit deutschlandweiten Daten <a href="https://rp-online.de/49723937">hier</a> getan.</p>
                </div>
            </div>
        )
    }
}